module.exports = __webpack_public_path__ + "static/media/84D6C403-CB62-49BE-8F4D-C20830A6DA28.5a431535.bin";